import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <section className="legal">
      <h2 data-en="PRIVACY POLICY">プライバシーポリシー</h2>
      <p>RubyMagic株式会社（以下「当社」）は、お問い合わせ等を通じて取得した個人情報を、回答・連絡その他お問い合わせ対応の目的の範囲で利用します。</p>
      <p>取得した個人情報は、法令に基づく場合を除き、ご本人の同意なく第三者に提供しません。</p>
      <p>当サイトでは、お問い合わせフォームとして外部サービス（Googleフォーム）を利用しています。入力された情報は当該サービスの仕組みにより送信・保管されます。</p>
      <p>個人情報の開示・訂正・削除等をご希望の場合は、お問い合わせフォームよりご連絡ください。</p>

    </section>
  );
};

export default Privacy;


